import React, { useState } from 'react';
import ScanIcon from '../../../components/Icons/ScanIcon';
import DownloadIcon from '../../../components/Icons/DownloadIcon';
import { SessionItem } from './SessionItem';
import { StartSessionModal } from './StartSessionModal';
import { useExportInventoryDiscrepanciesRequest, useExportInventoryRequest } from '../../../hooks/useApi';
import './ScanSessions.css';

const PlusIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 4V16M4 10H16" stroke="white" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const ScanSessions = ({inventoryId, sessionCount = 0, sessions = [], posId, onSessionCreated, inventoryStatus}) =>
{
  const [expandedSessionId, setExpandedSessionId] = useState(null);
  const [showStartModal, setShowStartModal] = useState(false);
  const [{ loading: exportLoading }, exportInventory] = useExportInventoryRequest(posId);
  const [{loading: exportDiscrepancyLoading}, exportInventoryDiscrepancy] = useExportInventoryDiscrepanciesRequest(posId);

  const handleExport = async () =>
  {
    const response = await exportInventory({ bodyParams: { inventoryId } });
    if (response?.data)
    {
      const blob = new Blob([response.data], { type: response.headers?.['content-type'] || 'application/octet-stream' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `inventory-${inventoryId}-export.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
    }
  };
  const handleExportDiscrepancies = async () =>
  {
    const response = await exportInventoryDiscrepancy({ bodyParams: { inventoryId } });
    if (response?.data)
    {
      const blob = new Blob([response.data], { type: response.headers?.['content-type'] || 'application/octet-stream' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `inventory-${inventoryId}-discrepancies.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
    }
  };
  const totalItemsScanned = sessions.reduce((total, session) =>
  {
    return total + (session.itemsScanned || 0);
  }, 0);

  const handleStartNewSession = () => setShowStartModal(true);

  const handleToggleSession = (sessionId) =>
  {
    setExpandedSessionId(expandedSessionId === sessionId ? null : sessionId);
  };

  if (!inventoryId || !posId)
  {
    return null;
  }

  return (
    <>
    <StartSessionModal
      isOpen={showStartModal}
      onClose={() => setShowStartModal(false)}
      inventoryId={inventoryId}
      posId={posId}
      onSessionCreated={() =>
      {
        setShowStartModal(false);
        onSessionCreated?.();
      }}
    />
    <div className="scan-sessions-container">
      <div className="scan-sessions-card">
        {/* Header */}
        <div className="scan-sessions-header">
          <div className="scan-sessions-header-left">
            <div className="scan-sessions-icon-wrapper">
              <ScanIcon width={24}/>
            </div>
            <h2 className="scan-sessions-title">Scan Sessions</h2>
          </div>
          <div className="inv-actions">
            <button
              onClick={handleExport}
              className="session-export-btn"
              disabled={exportLoading}
            >
              <DownloadIcon width={20} height={20} color={'#000'}/>
              <span>{exportLoading ? 'Exporting...' : 'Export All'}</span>
            </button>
            <button
              onClick={handleExportDiscrepancies}
              className="session-export-btn"
              disabled={exportDiscrepancyLoading}
            >
              <DownloadIcon width={20} height={20} color={'#000'}/>
              <span>{exportDiscrepancyLoading ? 'Exporting...' : 'Export Discrepancies'}</span>
            </button>
            {inventoryStatus !== 'COMPLETED' && inventoryStatus !== 'IN_REVIEW' && (
              <button
                onClick={handleStartNewSession}
                className="scan-sessions-start-btn"
              >
                <ScanIcon width={20} height={20} color={'#fff'}/>
                <span>Start New Session</span>
              </button>
            )}
          </div>
        </div>

        {/* Content */}
        <div className="scan-sessions-content">
          {sessionCount === 0 ? (
            <div className="scan-sessions-empty">
              <div className="scan-sessions-empty-icon">
                <ScanIcon width={24}/>
              </div>
              <p className="scan-sessions-empty-text">
                0 session uploaded
              </p>
            </div>
          ) : (
            <div className="scan-sessions-list">
              <div className="scan-sessions-count">
                <div className="session-stat">
                  <p>Session{sessionCount > 1 ? 's' : ''}</p>
                  <p className="font-extrabold accent-black">{sessionCount}</p>
                </div>
                <div className="session-stat">
                  <p>Scanned</p>
                  <p className="font-extrabold accent-black">{totalItemsScanned}</p>
                </div>
              </div>
              {sessions.map((session, index) => (
                <SessionItem
                  key={session.sessionId}
                  session={session}
                  sessionIndex={index + 1}
                  inventoryId={inventoryId}
                  posId={posId}
                  isExpanded={expandedSessionId === session.sessionId}
                  onToggle={() => handleToggleSession(session.sessionId)}
                  inventoryStatus={inventoryStatus}
                  onDeleted={onSessionCreated}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
    </>
  );
};
